"use strict";

Shopify.theme.jsPersonalProductRecommendations = {
  init($section) {

    const sectionId = $section.attr('id').replace('shopify-section-', '');

    const $productPageTargetContainer = $('[data-emarsys-products-container]')
    if ($productPageTargetContainer) {
      $productPageTargetContainer.append($section)
    }

    let logic;
    switch (true) {
      case /\/search/g.test(window.location.pathname):
        logic = 'SEARCH'
        break
      case /\/collection/g.test(window.location.pathname):
        logic = 'CATEGORY'
        break
      case /\/product/g.test(window.location.pathname):
        logic = 'RELATED'
        break
      case /\/cart/g.test(window.location.pathname):
        logic = 'CART'
        break
      default:
        logic = 'PERSONAL'
    }

    window.ScarabQueue.push(['recommend', {
      logic,
      containerId: `PersonalProductRecommendations-${sectionId}`,
      limit: 8,
      fail: function() {
       
      },
      failure: function() {
    
      },
      success: function (SC, render) {
        
        if (SC.page.products.length === 0) {
          $section.hide()
        }
        Promise.all(SC.page.products.map(({ link }) => fetch('/products/' + link.split('/').pop() + `${link.split('/').pop().includes('?') ? '&' : '?'}view=thumbnail`)))
          .then(responses => Promise.all(responses.map(response => response.text())))
          .then(htmlStrings => {

            SC.recommender.container.innerHTML = '';

            for (const [i, htmlString] of htmlStrings.entries()) {
              const div = document.createElement('div')
              div.innerHTML = htmlString;
              const thumbnail = div.firstElementChild;
              thumbnail.classList.add('one-fifth');
              thumbnail.classList.remove('one-fourth')
              thumbnail.dataset.scarabitem = SC.page.products[i].id;
              SC.recommender.container.appendChild(thumbnail)
            }

            $(SC.recommender.container).flickity({
              lazyLoad: 2,
              freeScroll: true,
              imagesLoaded: true,
              draggable: true,
              cellAlign: 'left',
              wrapAround: false,
              pageDots: false,
              contain: true,
              prevNextButtons: SC.page.products.length > 4,
              arrowShape: window.arrowShape
            });

            render(SC, true);

            SC.recommender.container.querySelectorAll('.product__grid-item').forEach(a => {
              window.stickerRemove && window.stickerRemove(a);
            })

            if(window.innerWidth < 749) {
                SC.recommender.container.querySelectorAll('.thumbnail-sticker').forEach(sticker => {
                    let pseudo = window.getComputedStyle(sticker, ':after');
                    if(pseudo.getPropertyValue("content") && pseudo.getPropertyValue("content") != "none") {
                        if(pseudo.getPropertyValue("content").length > 10) {
                            sticker.parentElement.style.top = '23px';
                            sticker.parentElement.style.right = '-25px';
                        }else if(pseudo.getPropertyValue("content").length > 7) {
                            sticker.parentElement.style.top = '18px';
                            sticker.parentElement.style.right = '-20px';
                        }
                    }
                })
            }
          })
          .catch(() => {
            $section.hide()
          })

      }
    }]);

  },
  unload: function unload($section) {
    console.log('Unload')
  }
};
